import { useContext, useEffect, useState } from "react";
import { Icon, SideSheet, Pane, Paragraph, HomeIcon } from "evergreen-ui";
import TabNav from "./TabNav";
import Tab from "../components/Tab";
import CaseMilestone from "./CaseMilestones";
import CaseMainDetails from "../components/CaseMainDetails";
import CaseQueries from "../components/CaseQueries";
import CaseNotes from "../components/CaseNotes";
import dummyCase from "../dummyJson/singleCase.json";
import dummyUserData from "../dummyJson/user.json";
import { IonFab, IonFabButton } from "@ionic/react";
import { globalContext } from "../global/Store";
import { CaseRoot } from "../global/Types";
import { dataRepoContext } from "../data-repo/DataRepo";
import { CreateCaseQuery, CreateCaseQueryResponse  } from "../global/Types";

const CaseDetails = (props: any) => {

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const { globalDataRepo } = useContext(dataRepoContext);

  const [selectedTab, setSelectedTab] = useState("Case Details");
  const [caseDetails, setCaseDetails] = useState<CaseRoot | null>(null);

  const closeComplete = () => {
    props.onCaseDetailsComplete();
  };

  const handleSetSelected = (tab: string) => {
    setSelectedTab(tab);
  };

  const handleRefreshList = (tab: string) => {
    props.onRefreshList();
  };

  useEffect(() => {
    globalDataRepo.GetCaseAllEntities(props.selectedCase).then(
      function (response: any) {
        setCaseDetails(response);
        console.log("full case details");
        console.log(response);
      },
      function (error: any) {
        console.error(error);

        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Read-Error",
          description: "Could not load case details",
          type: "danger",
          error: error
        });
      }
    );
  }, []);

  return (
    <SideSheet
      isShown={true}
      containerProps={{
        display: "flex",
        flex: "1",
        flexDirection: "column",
        marginTop: "90px !important",
        width: "100%",
        height: "100%",
        paddingBottom: "90px",
      }}
      width={"100%"}
    >
      <Pane flex="1" overflowY="auto" background="tint1" paddingTop={20}>
        <Paragraph
          paddingBottom={20}
          display="flex"
          float="right"
          marginRight={15}
          style={{ position: "fixed", right: "20px" }}
        >
          <b>Case Reference: {caseDetails?.caseRef}</b>
        </Paragraph>
        {!!caseDetails?.caseRef ? (
          <TabNav
            tabs={[
              "Case Details",
              "Case Milestones",
              "Case Queries",
              "Case Notes",
              
            ]}
            selected={selectedTab}
            setSelected={handleSetSelected}
          >
            <Tab isSelected={selectedTab === "Case Details"}>
              <CaseMainDetails 
                case={caseDetails} />
            </Tab>
            <Tab isSelected={selectedTab === "Case Milestones"}>
              <CaseMilestone
                case={caseDetails}
                selectedCase={caseDetails?.id}
              />
            </Tab>
            <Tab isSelected={selectedTab === "Case Queries"}>
              <CaseQueries
                case={caseDetails}
              />
            </Tab>
            <Tab isSelected={selectedTab === "Case Notes"}>
              <CaseNotes
                caseNotesList={caseDetails.caseNotes}
                case={caseDetails}
                selectedCase={caseDetails?.id}
              />
            </Tab>
          </TabNav>
        ) : null}
      </Pane>
      <IonFab
        onClick={() => closeComplete()}
        vertical="bottom"
        horizontal="start"
        edge
        slot="fixed"
        style={{ bottom: "10px", right: "15px", width: "50px" }}
      >
        <IonFabButton title="Home" style={{ width: "50px", height: "50px" }}>
          <Icon icon={HomeIcon} size={20} color="white" />
        </IonFabButton>
      </IonFab>
    </SideSheet>
  );
};

export default CaseDetails;
